import { render, staticRenderFns } from "./ProductManual.vue?vue&type=template&id=3a610577&"
import script from "./ProductManual.vue?vue&type=script&lang=js&"
export * from "./ProductManual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports